import React from "react";
import { connect } from "react-redux";

import { resetArticleDate } from "../../redux/actions/articles";
import styles from '../../styles/Components/Shared/ConfirmForm.module.css';

const ResetForm = ({
    resetArticleDate,
    handleClose,
    page,
    pageArticleType,
    searchTerm,
    newestFilter,
    manufacturerFilter,
    article: { selectedArticle },
}) => {
    const handleReset = (e) => {
        resetArticleDate(
            selectedArticle.article_id, 
            pageArticleType, 
            page, 
            searchTerm, 
            newestFilter, 
            manufacturerFilter
        );
        handleClose();
    };
    return (
        <>
            <div className={styles.confirm_modal_container}>
                <p className={styles.confirm_modal_header}>RESET COURSE DATE</p>
                <div>
                    <p className={styles.confirm_modal_text}>Are you sure you want to reset {selectedArticle?.title}'s date?</p>
                </div>
                <div className={styles.confirm_modal_button_container}>
                    <button  className={styles.confirm_modal_buttons} onClick={handleClose}>Cancel</button>
                    <button  className={styles.confirm_modal_buttons} onClick={handleReset}>Reset</button>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => ({
    article: state.article,
});

export default connect(mapStateToProps, {
    resetArticleDate,
})(ResetForm);
